export const ACCESS_LEVEL = {
    USER: "USER",
    USER_MANAGEMENT: "USER_MANAGEMENT",
    REPORTS: "REPORTS",
    ADMINISTRATION: "ADMINISTRATION",
};

export const ACCESS_LEVEL_DICTIONARY = {
    [ACCESS_LEVEL.USER]: "User",
    [ACCESS_LEVEL.USER_MANAGEMENT]: "User Management",
    [ACCESS_LEVEL.REPORTS]: "Reports",
    [ACCESS_LEVEL.ADMINISTRATION]: "Administration",
};
